module.exports = __webpack_public_path__ + "img/instagram.e20c08f1.svg";